<form [formGroup]="form" autocomplete="off" class="form-horizontal">

  <div class="form-row">
    <label class="col-sm-4 col-form-label"
           for="personenstand{{index}}">{{ 'COMMON_UI.PERSONENSTAND.PERSONENSTAND.LABEL' | translate }}</label>
    <div class="col-sm-8">
      <select class="form-control" datevMessagePath="personenstand{{objectId}}" formControlName="personenstand" id="personenstand{{index}}"
              utilsCheckValidity utilsControlState
              utilsValidationMessage>
        <option [ngValue]="null" selected>{{ 'COMMON_UI.PERSONENSTAND.PERSONENSTAND.NULL' | translate }}</option>
        <option *ngFor="let value of enumKeys(personenstandEnum)"
                [ngValue]="personenstandEnum[value]">{{ 'COMMON_UI.PERSONENSTAND.PERSONENSTAND.KEY_' + personenstandEnum[value] | translate }}
        </option>
      </select>
    </div>
  </div>

  <div *ngIf="data?.personenstand" class="form-row">
    <label class="col-sm-4 col-form-label"
           for="gueltigSeit{{index}}">{{ 'COMMON_UI.PERSONENSTAND.GUELTIG_SEIT' | translate }}</label>
    <div class="col-sm-8">
      <date-picker
              id="gueltigSeit{{index}}"
              messagePath="gueltigSeit{{objectId}}"
              formControlName="gueltigSeit"
              [isRequired]=true>
      </date-picker>
    </div>
  </div>

</form>
